import React, { Component } from 'react';
import { getClosedTrades } from '../services/closedTradeService';
import Spinner from './common/spinner';
import AddButton from './common/addButton';
import ClosedTradesTable from './closedTradesTable';

class ClosedTrades extends Component {
  state = {
    closedTrades: [],
    loading: false,
  };

  async componentDidMount() {
    this.setState({ loading: true });
    const result = await getClosedTrades();
    this.setState({ loading: false });
    const { data: closedTrades } = result.data;
    this.setState({ closedTrades });
  }

  getPagedData = () => {
    const { closedTrades } = this.state;

    return { data: closedTrades };
  };

  render() {
    const { data: closedTrades } = this.getPagedData();
    const { loading } = this.state;
    if (loading) return <Spinner message="loading page data..." />;
    return (
      <React.Fragment>
        <AddButton link="/closed-trades/new" value="Close a trade" />
        <ClosedTradesTable
          closedTrades={closedTrades}
          message="Closed Trades"
        />
      </React.Fragment>
    );
  }
}

export default ClosedTrades;
